import router from "../router";
import store from '../store'
import axios from 'axios';
/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
export function privatePhone(val,retain = 4){
    if(!Number(val) || String(val).length !== 11 || retain==0 ) return val;
    let mobile = String(val)
    let digit = 11 - 3 - retain
    let reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`)
    return mobile.replace(reg,`$1${'*'.repeat(digit)}$2`)
}
export function formatDate(value) {
    var val = value * 1000
    var date = new Date(val);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '.';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '.';
    var D = date.getDate() + ' ';
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y+M+D;
}
export function formatDate2(time, fmt) {
    var time = time * 1000
    var date = new Date(time);
    if(fmt==''){
        fmt = 'yyyy.MM.dd'
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    }
    return fmt
}

function padLeftZero(str) {
    return ('00' + str).substr(str.length)
}

function webUrl(val){
    return store.state.webinfo+val;
}

/**
 * 倒计时
 * @param endtime
 * @returns {string}
 * @constructor
 */
function InitTime(endtime){
    var dd,hh,mm,ss = null;
    var time = parseInt(endtime) - new Date().getTime();
    if(time<=0){
        return '结束'
    }else{
        dd = Math.floor(time / 60 / 60 / 24);
        hh = Math.floor((time / 60 / 60) % 24);
        mm = Math.floor((time / 60) % 60);
        ss = Math.floor(time  % 60);
        var str = dd+"天"+hh+"小时"+mm+"分"+ss+"秒";
        return str;
    }
}
function countDownFun(time) {
    time--;//时间一秒秒的减
    let nowTime = new Date().getTime(); //现在时间
    if(nowTime<=time){
//获取时间差
        let timediff=Math.round((time-nowTime)/1000);
//获取还剩多少天
        let day=parseInt(timediff/3600/24);
//获取还剩多少小时
        let hour=parseInt(timediff/3600%24);
//获取还剩多少分钟
        let minute=parseInt(timediff/60%60);
//获取还剩多少秒
        let second=timediff%60;
        return day +"天"+hour+"小时"+minute+"分"+second+"秒"
    }else{
        return "00天00小时00分00秒";
    }
}
function ellipsis (value,number,ext) {
    if (!value) return ''
    value = value.replace(/<[^>]+>/g, '')
    if (ext == true) {
        return value.slice(0, number)
    }
    if (value.length > number) {
        return value.slice(0, number) + '...'
    }

    return value
}
function getTimer(stringTime) {

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var month = day * 30;
    var time1 = new Date().getTime();//当前的时间戳
    var time2 = new Date(parseInt(stringTime)*1000)//指定时间的时间戳
    var time = time1 - time2;
    var result = null;
    if (time < 0) {
        // alert("设置的时间不能早于当前时间！");
    } else if (time / month >= 1) {
        result = parseInt(time / month)+"月前";
    } else if (time / week >= 1) {
        result =  parseInt(time / week)+"周前";
    } else if (time / day >= 1) {
        result =  parseInt(time / day)+"天前";
    } else if (time / hour >= 1) {
        result =  parseInt(time / hour)+"小时前";
    } else if (time / minute >= 1) {
        result =  parseInt(time / minute)+"分钟前";
    } else {
        result = "刚刚发布！";
    }
    return result;
}
/*分离位置*/
function degreelot(value,index){
    let arr = value.split(',')
    if(index ==1){
        return parseInt(arr[0])
    }
    return parseInt(arr[1])
}
function fileDownload(url,filename,title){
    axios.defaults.baseURL = '/files'  //关键代码
    axios.get(url,{params:{file_name:filename},responseType: 'blob'}).then((res)=>{
        const { data, headers } = res
        const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
        // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
        //const blob = new Blob([JSON.stringify(data)], ...)
        const blob = new Blob([data], {type: headers['content-type']})
        let dom = document.createElement('a')
        let url = window.URL.createObjectURL(blob)
        dom.href = url
        dom.download = decodeURI(fileName)
        dom.style.display = 'none'
        document.body.appendChild(dom)
        dom.click()
        dom.parentNode.removeChild(dom)
        window.URL.revokeObjectURL(url)
    })
}
function companytype(val){
    if(val==0){
        return '内资';
    }else if(val==1){
        return '外资';
    }else if(val==2){
        return '港资/台资';
    }else if(val==3){
        return '合资';
    }
}
// 以数组的形式存储函数
let list = [
    {name:'getTimer',fn:getTimer},
    {name:'privatePhone',fn:privatePhone},
    {name:'formatDate2',fn:formatDate2 },
    {name:'webUrl',fn:webUrl },
    {name:'countDownFun',fn:countDownFun},
    {name:'ellipsis',fn:ellipsis},
    {name:'degreelot',fn:degreelot},
    {name:'fileDownload',fn:fileDownload},
    {name:'formatDate',fn:formatDate},
    {name:'companytype',fn:companytype},
];

export default {
    install(Vue, opt) {
        list.forEach(item => {
            Vue.filter(item.name, item.fn);
        });
        // 防重复点击(指令实现)
        Vue.directive('preventReClick', {
            inserted (el, binding) {
                el.addEventListener('click', () => {
                    if (!el.disabled) {
                        el.disabled = true
                        setTimeout(() => {
                            el.disabled = false
                        }, binding.value || 3000)
                    }
                })
            }
        })
    }
};



// WEBPACK FOOTER //
// ./src/plugins/filters.js